module.exports = __webpack_public_path__ + "img/New Asian Cinema.c9ef47e7.jpg";